"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _constants = require("../constants");
var _enums = require("./enums");
/**
 * The Controls Options Manager utilities
 *
 * @internal
 */
var Utils = /*#__PURE__*/function () {
  function Utils() {
    (0, _classCallCheck2.default)(this, Utils);
  }
  (0, _createClass2.default)(Utils, null, [{
    key: "canSetMuteOnEntry",
    value:
    /**
     * Validate if enabling mute on entry can be set.
     *
     * @param {Array<string>} displayHints - Display Hints to use when validating.
     * @returns {boolean} - True if the action is allowed.
     */
    function canSetMuteOnEntry(displayHints) {
      return displayHints.includes(_constants.DISPLAY_HINTS.ENABLE_MUTE_ON_ENTRY);
    }

    /**
     * Validate if allowing unmuting can be set.
     *
     * @param {Array<string>} displayHints - Display Hints to use when validating.
     * @returns {boolean} - True if the action is allowed.
     */
  }, {
    key: "canSetDisallowUnmute",
    value: function canSetDisallowUnmute(displayHints) {
      return displayHints.includes(_constants.DISPLAY_HINTS.ENABLE_HARD_MUTE);
    }

    /**
     * Validate if disabling mute on entry can be set.
     *
     * @param {Array<string>} displayHints - Display Hints to use when validating.
     * @returns {boolean} - True if the action is allowed.
     */
  }, {
    key: "canUnsetMuteOnEntry",
    value: function canUnsetMuteOnEntry(displayHints) {
      return displayHints.includes(_constants.DISPLAY_HINTS.DISABLE_MUTE_ON_ENTRY);
    }

    /**
     * Validate if enabling muting can be set.
     *
     * @param {Array<string>} displayHints - Display Hints to use when validating.
     * @returns {boolean} - True if the action is allowed.
     */
  }, {
    key: "canUnsetDisallowUnmute",
    value: function canUnsetDisallowUnmute(displayHints) {
      return displayHints.includes(_constants.DISPLAY_HINTS.DISABLE_HARD_MUTE);
    }

    /**
     * Validate if muting all can be set.
     *
     * @param {Array<string>} displayHints - Display Hints to use when validating.
     * @returns {boolean} - True if the action is allowed.
     */
  }, {
    key: "canSetMuted",
    value: function canSetMuted(displayHints) {
      return displayHints.includes(_constants.DISPLAY_HINTS.MUTE_ALL);
    }

    /**
     * Validate if unmuting all can be set.
     *
     * @param {Array<string>} displayHints - Display Hints to use when validating.
     * @returns {boolean} - True if the action is allowed.
     */
  }, {
    key: "canUnsetMuted",
    value: function canUnsetMuted(displayHints) {
      return displayHints.includes(_constants.DISPLAY_HINTS.UNMUTE_ALL);
    }

    /**
     * Validate an array of hints are allowed based on a full collection of hints.
     *
     * @param {Object} config - Configuration Object.
     * @param {Array<string>} config.requiredHints - Hints required for validation.
     * @param {Array<string>} config.displayHints - All available hints.
     * @returns {boolean} - True if all of the actions are allowed.
     */
  }, {
    key: "hasHints",
    value: function hasHints(config) {
      var requiredHints = config.requiredHints,
        displayHints = config.displayHints;
      return requiredHints.every(function (hint) {
        return displayHints.includes(hint);
      });
    }

    /**
     * Validate that the self policy object contains the required policies.
     *
     * @param {Object} config - Configuration Object.
     * @param {Array<string>} config.requiredPolicies - Policies required for validation.
     * @param {Array<string>} config.policies - All available policies.
     * @returns {boolean} - True if all of the actions are allowed.
     */
  }, {
    key: "hasPolicies",
    value: function hasPolicies(config) {
      var requiredPolicies = config.requiredPolicies,
        _config$policies = config.policies,
        policies = _config$policies === void 0 ? {} : _config$policies;
      return requiredPolicies.every(function (hint) {
        return policies[hint];
      });
    }

    /**
     * Validate if an audio-scoped control is allowed to be sent to the service.
     *
     * @param {ControlConfig<AudioProperties>} control - Audio control config to validate.
     * @param {Array<string>} displayHints - All available hints.
     * @returns {boolean} - True if all of the actions are allowed.
     */
  }, {
    key: "canUpdateAudio",
    value: function canUpdateAudio(control, displayHints) {
      var requiredHints = [];
      if (control.properties.muted === true) {
        requiredHints.push(_constants.DISPLAY_HINTS.MUTE_ALL);
      }
      if (control.properties.muted === false) {
        requiredHints.push(_constants.DISPLAY_HINTS.UNMUTE_ALL);
      }
      if (control.properties.disallowUnmute === true) {
        requiredHints.push(_constants.DISPLAY_HINTS.ENABLE_HARD_MUTE);
      }
      if (control.properties.disallowUnmute === false) {
        requiredHints.push(_constants.DISPLAY_HINTS.DISABLE_HARD_MUTE);
      }
      if (control.properties.muteOnEntry === true) {
        requiredHints.push(_constants.DISPLAY_HINTS.ENABLE_MUTE_ON_ENTRY);
      }
      if (control.properties.muteOnEntry === false) {
        requiredHints.push(_constants.DISPLAY_HINTS.DISABLE_MUTE_ON_ENTRY);
      }
      return Utils.hasHints({
        requiredHints: requiredHints,
        displayHints: displayHints
      });
    }
  }, {
    key: "canUpdateRaiseHand",
    value: function canUpdateRaiseHand(control, displayHints) {
      var requiredHints = [];
      if (control.properties.enabled === true) {
        requiredHints.push(_constants.DISPLAY_HINTS.ENABLE_RAISE_HAND);
      }
      if (control.properties.enabled === false) {
        requiredHints.push(_constants.DISPLAY_HINTS.DISABLE_RAISE_HAND);
      }
      return Utils.hasHints({
        requiredHints: requiredHints,
        displayHints: displayHints
      });
    }

    /**
     * Validate if an reactions-scoped control is allowed to be sent to the service.
     *
     * @param {ControlConfig<ReactionsProperties>} control - Reaction control config to validate.
     * @param {Array<string>} displayHints - All available hints.
     * @returns {boolean} - True if all of the actions are allowed.
     */
  }, {
    key: "canUpdateReactions",
    value: function canUpdateReactions(control, displayHints) {
      var requiredHints = [];

      // This additional if statement avoids the display hint discrepency due to
      // the service blocking partial requests with this property only.
      if (control.properties.showDisplayNameWithReactions !== undefined) {
        if (control.properties.showDisplayNameWithReactions === true) {
          requiredHints.push(_constants.DISPLAY_HINTS.ENABLE_SHOW_DISPLAY_NAME);
        }
        if (control.properties.showDisplayNameWithReactions === false) {
          requiredHints.push(_constants.DISPLAY_HINTS.DISABLE_SHOW_DISPLAY_NAME);
        }
      } else {
        if (control.properties.enabled === true) {
          requiredHints.push(_constants.DISPLAY_HINTS.ENABLE_REACTIONS);
        }
        if (control.properties.enabled === false) {
          requiredHints.push(_constants.DISPLAY_HINTS.DISABLE_REACTIONS);
        }
      }
      return Utils.hasHints({
        requiredHints: requiredHints,
        displayHints: displayHints
      });
    }

    /**
     * Validate if an share-control-scoped control is allowed to be sent to the service.
     *
     * @param {Array<string>} displayHints - All available hints.
     * @returns {boolean} - True if all of the actions are allowed.
     */
  }, {
    key: "canUpdateShareControl",
    value: function canUpdateShareControl(displayHints) {
      return Utils.hasHints({
        requiredHints: [_constants.DISPLAY_HINTS.SHARE_CONTROL],
        displayHints: displayHints
      });
    }

    /**
     * Validate if an view-the-participants-list-scoped control is allowed to be sent to the service.
     *
     * @param {ControlConfig<ViewTheParticipantListProperties>} control - View Participants List control config to validate.
     * @param {Array<string>} displayHints - All available hints.
     * @returns {boolean} - True if all of the actions are allowed.
     */
  }, {
    key: "canUpdateViewTheParticipantsList",
    value: function canUpdateViewTheParticipantsList(control, displayHints) {
      var requiredHints = [];
      if (control.properties.enabled === true) {
        requiredHints.push(_constants.DISPLAY_HINTS.ENABLE_VIEW_THE_PARTICIPANT_LIST);
      }
      if (control.properties.enabled === false) {
        requiredHints.push(_constants.DISPLAY_HINTS.DISABLE_VIEW_THE_PARTICIPANT_LIST);
      }
      if (control.properties.panelistEnabled === true) {
        requiredHints.push(_constants.DISPLAY_HINTS.ENABLE_VIEW_THE_PARTICIPANT_LIST_PANELIST);
      }
      if (control.properties.panelistEnabled === false) {
        requiredHints.push(_constants.DISPLAY_HINTS.DISABLE_VIEW_THE_PARTICIPANT_LIST_PANELIST);
      }
      if (control.properties.attendeeCount === true) {
        requiredHints.push(_constants.DISPLAY_HINTS.ENABLE_SHOW_ATTENDEE_COUNT);
      }
      if (control.properties.attendeeCount === false) {
        requiredHints.push(_constants.DISPLAY_HINTS.DISABLE_SHOW_ATTENDEE_COUNT);
      }
      return Utils.hasHints({
        requiredHints: requiredHints,
        displayHints: displayHints
      });
    }

    /**
     * Validate if a video-scoped control is allowed to be sent to the service.
     *
     * @param {ControlConfig<VideoProperties>} control - Video control config to validate.
     * @param {Array<string>} displayHints - All available hints.
     * @returns {boolean} - True if all of the actions are allowed.
     */
  }, {
    key: "canUpdateVideo",
    value: function canUpdateVideo(control, displayHints) {
      var requiredHints = [];
      if (control.properties.enabled === true) {
        requiredHints.push(_constants.DISPLAY_HINTS.ENABLE_VIDEO);
      }
      if (control.properties.enabled === false) {
        requiredHints.push(_constants.DISPLAY_HINTS.DISABLE_VIDEO);
      }
      return Utils.hasHints({
        requiredHints: requiredHints,
        displayHints: displayHints
      });
    }

    /**
     * Validate that a control can be sent to the service based on the provided
     * display hints.
     *
     * @param {ControlConfig} control - Control to validate.
     * @param {Array<string>} displayHints - All available hints.
     * @returns {boolean} - True if all of the actions are allowed.
     */
  }, {
    key: "canUpdate",
    value: function canUpdate(control, displayHints) {
      var determinant;
      switch (control.scope) {
        case _enums.Control.audio:
          determinant = Utils.canUpdateAudio(control, displayHints);
          break;
        case _enums.Control.raiseHand:
          determinant = Utils.canUpdateRaiseHand(control, displayHints);
          break;
        case _enums.Control.reactions:
          determinant = Utils.canUpdateReactions(control, displayHints);
          break;
        case _enums.Control.shareControl:
          determinant = Utils.canUpdateShareControl(displayHints);
          break;
        case _enums.Control.video:
          determinant = Utils.canUpdateVideo(control, displayHints);
          break;
        case _enums.Control.viewTheParticipantList:
          determinant = Utils.canUpdateViewTheParticipantsList(control, displayHints);
          break;
        default:
          determinant = false;
      }
      return determinant;
    }
  }]);
  return Utils;
}();
var _default = exports.default = Utils;
//# sourceMappingURL=util.js.map
